export default "__VITE_ASSET__D19xmCF6__"